var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../../../../../node_modules/ts-loader/index.js??ruleSet[1].rules[0]!./tooltip.ts");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["fit_page_tooltip"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["fit_page_tooltip"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
